import axios from 'axios'

export default {
  namespaced: true,
  state: {
    config: {},
    modConfig: {}
  },

  mutations: {
    SET_CONFIG (state, config) {
      state.config = JSON.parse(JSON.stringify(config))
      state.modConfig = JSON.parse(JSON.stringify(config))
      localStorage.setItem('theme', state.config.theme)
      localStorage.setItem('lang', state.config.lang)
    }
  },

  getters: {},

  actions: {
    async get ({ commit }) {
      let data = await axios.get('/config')
      commit('SET_CONFIG', data.data)
    },

    async update ({ commit }, config) {
      let data = await axios.patch('/config', { config: JSON.stringify(config) })
      commit('SET_CONFIG', config)
      return data
    }
  }
}
